import { jobPostTensionLoader } from 'loaders/jobPostTensionLoader';
import { jobProjectionsLoader } from 'loaders/jobProjectionsLoader';
import { jobSubmittalLoader } from 'loaders/jobSubmittalLoader';
import { Suspense, lazy } from 'react';
import {
    Outlet,
    Route,
    RouterProvider,
    createBrowserRouter,
    createRoutesFromElements
} from 'react-router-dom';
import { loader as userLoader } from './auth/authorize';
import * as Paths from './routes';
const Home = lazy(() => import('./pages/Home/index'));
const Login = lazy(() => import('./pages/Login/index'));
const Messages = lazy(() => import('./pages/Messages'));
const Message = lazy(() => import('./pages/Messages/message'));
const Hardwares = lazy(() => import('./pages/PT/Cable/hardwares'));
const PTQuantites = lazy(() => import('./pages/PT/Cable/ptQuantities'));
const PTIFiling = lazy(() => import('./pages/PT/Cable/ptiFiling'));
const CISUploadDocuments = lazy(() => import('./pages/PT/Job/cisUploadDocuments'));
const Contacts = lazy(() => import('./pages/PT/Job/contacts'));
const CreateJob = lazy(() => import('./pages/PT/Job/createJob'));
const Estimates = lazy(() => import('./pages/PT/Job/estimates'));
const ImportFabJob = lazy(() => import('./pages/PT/Job/importFabJob'));
const JobsLayout = lazy(() => import('./pages/PT/Job/jobsLayout'));
const StudRailQuantitiesAccessories = lazy(() => import('./pages/PT/StudRail/studRailQuantitiesChairs'));
const RedirectPTHome = lazy(() => import('./pages/PT/redirectPTHome'));
const NotFound = lazy(() => import('./pages/notfound'));
const Unauthorized = lazy(() => import('./pages/unauthorized'));
const MainInfo = lazy(() => import('./pages/PT/Job/mainInfo'));
const CutImport = lazy(() => import('./pages/PT/Cable/cutImport'));
const BCAdditionalItems = lazy(() => import('./pages/PT/Cable/bcAdditionalItems'));
const PTHome = lazy(() => import('./pages/PT'));
const AccessoriesComponents = lazy(() => import('./pages/PT/Cable/accessories'));
const AdminIndex = lazy(() => import('./pages/PT/Admin'));
const ErrorBoundary = lazy(() => import('./components/shared/errorBoundary'));
const FabJobImportRedirect = lazy(() => import('./components/Redirects/fabJobImportRedirect'));
const RedirectQuantites = lazy(() => import('./components/PT/PTQuantities/redirectPTQuantites'));
const LinkDrawings = lazy(() => import('./components/PT/PTQuantities/linkDrawings'));
const PTLayout = lazy(() => import('./components/Layout/ptLayout'));
const Layout = lazy(() => import('./components/Layout/layout'));
const Authorize = lazy(() => import('./auth/authorize'));
const Authenticate = lazy(() => import('./auth/authentication'));
const RouterErrorPage = lazy(() => import('pages/routerErrorPage'));
const CutParts = lazy(() => import('pages/PT/StudRail/cutParts'));
const MessagingPolicy = lazy(() => import('pages/Home/messagingPolicy'));
const ShopPaperWork = lazy(() => import('./pages/PT/Schedule/shopPaperWork'));
const StudRailQuantities = lazy(() => import('./pages/PT/StudRail/studRailQuantities'));
const Parts = lazy(() => import('./pages/PT/Admin/parts'));
const RedirectToStudrail = lazy(() => import('components/PT/StudRail/redirectToStudrail'));

const SubmittalsLayout = lazy(() => import('./components/Layout/Submittals/submittalsLayout'));
const SubmittalsHomeLayout = lazy(() => import('./components/Layout/Submittals/submittalsHomeLayout'));
const SubmittalsJobLayout = lazy(() => import('./components/Layout/Submittals/submittalsJobLayout'));
const SubmittalsHome = lazy(() => import('./pages/Submittals/submittalsHome'));

const SubmittalsPage = lazy(() => import('./pages/Submittals/Job/submittals'));
const ListedSubmittals = lazy(() => import('./pages/Submittals/Job/listedSubmittals'));

const NewSubmittal = lazy(() => import('./pages/Submittals/Job/newSumittal'));
const EditSubmittal = lazy(() => import('./pages/Submittals/Job/editSubmittal'));
const DeleteSubmittal = lazy(() => import('./pages/Submittals/Job/deleteSubmittal'));
const ReturnedApprovals = lazy(() => import('./pages/Submittals/Job/returnedApprovals'));

//projections
const ProjectionsLayout = lazy(() => import('./components/Layout/Projections/projectionsLayout'));
const ProjectionsHomeLayout = lazy(() => import('./components/Layout/Projections/projectionsHomeLayout'));
const ProjectionsHome = lazy(() => import('./pages/Projections/projectionsHome'));
const ManageProjections = lazy(() => import('./pages/Projections/manageProjections'));

const ProjectionsJobLayout = lazy(() => import('./components/Layout/Projections/projectionsJobLayout'));
const JobProjections = lazy(() => import('./pages/Projections/jobProjections'));
const AddEditProjections = lazy(() => import('./pages/Projections/AddEdit/addEditProjections'));
const MoveProjections = lazy(() => import('./pages/Projections/AddEdit/Move/moveProjections'));
const ProjectionsLogs = lazy(() => import('./pages/Projections/AddEdit/Move/Logs/projectionsLogs'));

//schedules
const ScheduleLayout = lazy(() => import('./components/PT/Schedules/schedulesLayout'));
const Schedules = lazy(() => import('./pages/PT/Schedule/schedules'));
const RedirectSchedules = lazy(() => import('./components/PT/Schedules/redirectSchedules'));

//detailing time entry
const DetailingTimeEntryLayout = lazy(() => import('./components/Layout/DetailingTimeEntry/detailingTimeEntryLayout'));
const DetailingTimeEntryHome = lazy(() => import('./pages/DetailingTimeEntry/detailingTimeEntryHome'));

//admin
const PTAdminLayout = lazy(() => import('./components/Layout/ptAdminLayout'));
const PartClass = lazy(() => import('./pages/PT/Admin/partClass'));
const FabConfig = lazy(() => import('./pages/PT/Admin/fabConfig'));
const KitConfig = lazy(() => import('./pages/PT/Admin/kitConfig'));

export default function Router({ queryClient }) {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path={Paths.ROUTE_DEFAULT} errorElement={RouterErrorPage}>
          <Route path="messaging-policy" element={<MessagingPolicy />}></Route>
          <Route element={<Authenticate />}>
            <Route loader={() => userLoader(queryClient)} element={<Authorize />} errorElement={<ErrorBoundary />}>
              <Route element={<Layout />}>
                <Route path={''} element={<Home />} />
                <Route path={'home'} element={<Home />} />

                {/* message routes  */}
                <Route path={Paths.ROUTE_MESSAGES}>
                  <Route index element={<Messages />} />
                  <Route path={':id'} element={<Message />} />
                </Route>
              </Route>

              {/* fabrication routes  */}
              <Route path={'FAB'} element={<JobsLayout />}>
                <Route index element={<FabJobImportRedirect />} />
                <Route path={'newjob'} element={<ImportFabJob />} />
                <Route path={'jobs'}>
                  <Route index element={<FabJobImportRedirect />} />
                  <Route path={':jobId'} element={<MainInfo />} />
                </Route>
              </Route>

              {/* pt routes  */}
              <Route path={'/PT'} element={<PTLayout />}>
                <Route index element={<PTHome />} />
                <Route path={'newjob'} element={<CreateJob />} />
                {/* jobs routes  */}
                <Route path={'jobs'} element={<Outlet />}>
                  <Route index element={<RedirectPTHome />} />
                  <Route path={':jobId'} id="postTensionJob" loader={jobPostTensionLoader} element={<Outlet />}>
                    <Route index element={<MainInfo />} />
                    <Route path={'estimates'} element={<Estimates />} />
                    <Route path={'contacts'} element={<Contacts />} />
                    <Route path={'pt-quantities'} element={<Outlet />}>
                      <Route index element={<PTQuantites />} />
                      <Route path={':loadDescription'} element={<Outlet />}>
                        <Route index element={<RedirectQuantites />} />
                        <Route path={'Accessories'} element={<AccessoriesComponents />} />
                        <Route path={'Barrier Cable Steel Post & ACC'} element={<AccessoriesComponents />} />
                        <Route path={'Link Drawings'} element={<LinkDrawings />} />
                        <Route path={'PTI Filing'} element={<PTIFiling />} />
                        <Route path={'cut-import'} element={<CutImport />} />
                        <Route path={'cuts'} element={<Outlet />}>
                          <Route index element={<RedirectQuantites />} />
                          <Route path={'Hardwares'} element={<Hardwares />} />
                          <Route path={'Barrier Cable Additional Components'} element={<BCAdditionalItems />} />
                        </Route>
                      </Route>
                    </Route>
                    <Route path={'studrails_quantities'}>
                      <Route id={'studRailQuantities'} index element={<StudRailQuantities />} />
                      <Route path=":loadDescription" element={<Outlet />}>
                        <Route index element={<RedirectToStudrail />} />
                        <Route path=":loadId" element={<Outlet />}>
                          <Route index element={<RedirectToStudrail />} />
                          <Route path="cuts" element={<Outlet />}>
                            <Route index element={<RedirectToStudrail />} />
                            <Route path=":cutNo" element={<Outlet />}>
                              <Route index element={<RedirectToStudrail />} />
                              <Route path=":cutId" element={<Outlet />}>
                                <Route index element={<RedirectToStudrail />} />
                                <Route id="cutParts" path="parts" element={<CutParts />} />
                              </Route>
                            </Route>
                          </Route>
                        </Route>
                      </Route>
                      <Route path={':loadDescription'} element={<Outlet />}>
                        <Route index element={<RedirectQuantites />} />
                        <Route path={'cut-import'} element={<CutImport />} />
                        <Route path={'Chairs'} element={<StudRailQuantitiesAccessories />} />
                      </Route>
                    </Route>
                    <Route path={'mainInfo'} element={<Outlet />}>
                      <Route index element={<MainInfo />} />
                      <Route path={Paths.ROUTE_CIS_DOCUMENTS_UPLOAD} element={<CISUploadDocuments />} />
                    </Route>
                  </Route>
                </Route>

                {/* admin routes */}
                <Route path={'admin'} element={<PTAdminLayout />}>
                  <Route index element={<AdminIndex />} />
                  <Route path={Paths.ROUTE_PT_ADMIN_PARTCLASS} element={<PartClass />} />
                  <Route path={Paths.ROUTE_PT_ADMIN_PART} element={<Parts />} />
                  <Route path={Paths.ROUTE_PT_ADMIN_FABCONFIG} element={<FabConfig />} />
                  <Route path={Paths.ROUTE_PT_ADMIN_KITCONFIG} element={<KitConfig />} />
                </Route>

                {/* schedules routes  */}
                <Route path={'schedules'} element={<ScheduleLayout />}>
                  <Route index element={<Schedules />} />
                  <Route path={Paths.ROUTE_PT_SHOP_PAPER_WORK} element={<ShopPaperWork />} />
                  <Route path={Paths.ROUTE_PT_SCHEDULES_REDIRECT_JOB} element={<RedirectSchedules />} />
                  <Route path={Paths.ROUTE_PT_SCHEDULES_REDIRECT_LOAD} element={<RedirectSchedules />} />
                </Route>
              </Route>

              {/* projections routes */}
              <Route path={'projections'} element={<ProjectionsLayout />}>
                <Route path="" element={<ProjectionsHomeLayout />}>
                  <Route index element={<ProjectionsHome />} />
                </Route>
                <Route path="manage projections" element={<ManageProjections />} />
                <Route
                  path=":jobId"
                  id="projectionsJob"
                  loader={jobProjectionsLoader}
                  element={<ProjectionsJobLayout />}
                >
                  <Route index element={<JobProjections />} />
                  <Route path="add-edit">
                    <Route index element={<AddEditProjections />} />
                    <Route path="move projections">
                      <Route index element={<MoveProjections />} />
                      <Route path="logs">
                        <Route index element={<ProjectionsLogs />} />
                      </Route>
                    </Route>
                  </Route>
                </Route>
              </Route>

              {/* detailing time entry routes  */}
              <Route path={'detailing time entry'} element={<DetailingTimeEntryLayout />}>
                <Route index element={<DetailingTimeEntryHome />} />
              </Route>

              {/* submittals routes */}
              <Route path="submittals" element={<SubmittalsLayout />}>
                <Route path="" element={<SubmittalsHomeLayout />}>
                  <Route index element={<SubmittalsHome />} />
                </Route>
                <Route
                  path=":jobId"
                  id="subJobLayout"
                  loader={({ params }) => jobSubmittalLoader({ params, queryClient })}
                  element={<SubmittalsJobLayout />}
                >
                  {/* default to submitted route */}
                  <Route index element={<SubmittalsPage />}/>
                  {/* <Route path="submitted" element={<SubmittalsPage />} /> */}

                  <Route path="submitted" element={<SubmittalsPage />} />
                  <Route path="listed" element={<ListedSubmittals />} />

                  <Route path="new" element={<NewSubmittal />} />
                  <Route path=":submittalNumber" element={<Outlet />}>
                    <Route index element={<EditSubmittal />} />
                    <Route path="delete" element={<DeleteSubmittal />} />
                    <Route path="returned approvals" element={<ReturnedApprovals />} />                     
                  </Route>
                  <Route index element={<DetailingTimeEntryHome />} />
                </Route>
              </Route>
            </Route>
          </Route>

          {/* error  */}
          <Route path={Paths.ROUTE_UNAUTHORIZED_USER} element={<Unauthorized />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path={Paths.ROUTE_LOGIN} element={<Login />} />
      </>
    )
  );

  return (
    <Suspense>
      <RouterProvider router={router} />
    </Suspense>
  );
}
